import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../../data/mockData";
import { Send, CheckCircle } from "lucide-react";

const FormInput = ({ label, required, ...inputProps }) => (
  <div>
    <label className="block text-sm font-medium text-[#1B2A1B] mb-1.5">
      {label} {required && <span className="text-red-400">*</span>}
    </label>
    <input
      {...inputProps}
      required={required}
      className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#3A7D44]/20 focus:border-[#3A7D44] transition-colors"
    />
  </div>
);

const SuccessMessage = () => (
  <div className="text-center py-12">
    <div className="w-16 h-16 bg-[#E8F5E9] rounded-full flex items-center justify-center mx-auto mb-4">
      <CheckCircle size={32} className="text-[#3A7D44]" />
    </div>
    <h3 className="text-xl font-bold text-[#1B2A1B] mb-2">Thank You!</h3>
    <p className="text-[#5A6B5A]">Your message has been received. I'll be in touch soon.</p>
  </div>
);

const ContactForm = () => {
  const [formData, setFormData] = React.useState({});
  const [isSubmitted, setIsSubmitted] = React.useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 5000);
    setFormData({});
  };

  if (isSubmitted) {
    return <SuccessMessage />;
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <FormInput
          label="First Name"
          required
          type="text"
          name="firstName"
          value={formData.firstName || ""}
          onChange={handleChange}
          placeholder="Your first name"
        />
        <FormInput
          label="Last Name"
          required
          type="text"
          name="lastName"
          value={formData.lastName || ""}
          onChange={handleChange}
          placeholder="Your last name"
        />
      </div>

      <div className="grid sm:grid-cols-2 gap-5">
        <FormInput
          label="Email"
          required
          type="email"
          name="email"
          value={formData.email || ""}
          onChange={handleChange}
          placeholder="your@email.com"
        />
        <FormInput
          label="Phone"
          required
          type="tel"
          name="phone"
          value={formData.phone || ""}
          onChange={handleChange}
          placeholder="(555) 555-5555"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-[#1B2A1B] mb-1.5">
          What type of coverage are you looking for? <span className="text-red-400">*</span>
        </label>
        <select
          name="coverageType"
          required
          value={formData.coverageType || ""}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#3A7D44]/20 focus:border-[#3A7D44] transition-colors bg-white"
        >
          <option value="">Select one...</option>
          <option value="Individual">Individual</option>
          <option value="Family">Family</option>
          <option value="Small Business / Group">Small Business / Group</option>
          <option value="Self-Employed">Self-Employed</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-[#1B2A1B] mb-1.5">
          Tell me a little about your situation
        </label>
        <textarea
          name="message"
          rows="4"
          value={formData.message || ""}
          onChange={handleChange}
          className="w-full px-4 py-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-[#3A7D44]/20 focus:border-[#3A7D44] transition-colors resize-none"
          placeholder="What are you looking for help with? Any specific concerns?"
        />
      </div>

      <button
        type="submit"
        className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold text-white bg-[#3A7D44] rounded-lg hover:bg-[#2D5A35] transition-colors w-full sm:w-auto justify-center"
      >
        <Send size={16} />
        Send Message
      </button>
    </form>
  );
};

export default ContactForm;
